import WorkflowElement from "../..//element"
import { flow } from "lodash"

import {
  renderPreviewNodes,
  layoutGraph,
  determineConditionOrder,
  styleGraph,
  positionNodes,
  renderSVGCanvas
} from "./renderer"

/**
 * Defines `workflow-preview-graph` element. Main entry point to render preview
 * versions of va's. Responsible for composing it's own render pipeline, parsing
 * raw JSON provided by Workflow::Graph.as_json.
 */
export default class PreviewGraph extends WorkflowElement {
  roots() {
    return JSON.parse(this.dataset.roots)
  }

  nodes() {
    const nodes = JSON.parse(this.dataset.nodes)

    // All graphs will have at least the ending node (1) so we'll consider
    // graphs with 1 or less nodes as new, they'll just have the start node.
    if (nodes.length > 1) {
      return nodes.map(n => ({ ...n, active: true }))
    } else {
      return [{ kind: "start", sources: [], siblings: [], active: true }]
    }
  }

  edges() {
    return JSON.parse(this.dataset.paths)
  }

  notes() {
    return JSON.parse(this.dataset.notes) || []
  }

  new_template_preview() {
    return !!this.dataset.newTemplatePreview
  }

  connectedCallback() {
    this.clear()

    const zoom = (this.dataset.zoom || 1) * 0.55

    return this.render({
      roots: this.roots(),
      nodes: this.nodes(),
      edges: this.edges(),
      scope: this,
      layout: { zoom: zoom },
      new_template_preview: this.new_template_preview()
    })
  }

  render(data) {
    const nudgeSafari = () => {
      // Fix for https://github.com/ConvertKit/convertkit/issues/11099
      if (!window.safari) return
      this.parentElement.style.display = "none"
      setTimeout(el => (el.style.display = ""), 10, this.parentElement)
    }
    const render = flow([
      renderPreviewNodes,
      layoutGraph,
      determineConditionOrder,
      styleGraph,
      positionNodes,
      renderSVGCanvas,
      nudgeSafari
    ])

    return render(data)
  }

  clear = () => {
    this.querySelectorAll("workflow-end, workflow-preview-node").forEach(node =>
      node.remove()
    )
  }
}

customElements.get("workflow-preview-graph") ||
  customElements.define("workflow-preview-graph", PreviewGraph)
